import React from "react";
import About from "../components/Footer/About";

function AboutPage() {
  return (
    <div>
      <About />
    </div>
  );
}

export default AboutPage;
